<template>
  <div id="page-product-details">
    <section-products-additive-form
        v-model="model"
        ref="form"
        :loading="loading"
        @deleteProduct="deleteProduct"
    />
  </div>
</template>

<script>

import NotificationMixin from '@/components/mixins/NotificationMixin';
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SectionProductsAdditiveForm from '@/views/pages/facilities/sections/products/SectionProductsAdditiveForm';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

export default {
  name: "SectionProducts",
  components: {
    SectionProductsAdditiveForm,
  },
  mixins: [SaveModelMixin, ViewModelMixin, NotificationMixin, CanAccessMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.facilities.sections,
      entity: 'Section Products',
      componentAccess: {
        canEdit: {
          route: 'facilities.sections.products.edit',
          access: false,
        },
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.sectionId;
    }
  },
  methods: {
    getParams() {
      const params = this.getModelCopy();

      const multiReferences = [
        {
          array: 'products',
          key: ['Product_FK', 'PrintIssueMethod_FK', 'PrintIssueSystem_FK'],
        },
      ];

      this.setMultiReferences(multiReferences);

      delete params.Facility_FK;
      delete params.Section_FK;

      return params;
    },
    async fetch() {
      try {
        const { data } = await this.$api.facilities.sections.products(this.id)
        this.model = {
          id: this.id,
          products: data.data,
        }
      } catch (e) {
        console.log(e);
      }
    },
    async deleteProduct(productId) {
      this.loading = true;

      try {
        const {data} = await this.$api.facilities.sections.deleteProduct(
            this.$route.params.sectionId,
            productId
        );

        this.notifySuccess('Section Product updated');
      } catch (e) {
        this.notifyError('Section Product failed to be update');
        console.error(e)
      } finally {
        await this.reloadForm();

        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
